import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"1.7em","color":"white"},
  class: "fas fa-upload m-1"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cargarDocumento(_ctx.id))),
      type: "button",
      style: {"margin-right":"10px"},
      class: _normalizeClass(_ctx.state==='active'?'badge badge-success':'badge badge-primary'),
      title: _ctx.state==='active'?'Subir documento restricción':'Subir documento levantamiento restricción'
    }, _hoisted_3, 10, _hoisted_1),
    _createElementVNode("input", {
      id: _ctx.id,
      type: "file",
      ref: "file",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFileUpload($event, _ctx.id))),
      accept: "application/pdf",
      hidden: ""
    }, null, 40, _hoisted_4)
  ], 64))
}